import React from 'react';

const ReceiptExtractionStatus = ({ isLoading }) => {
  if (!isLoading) return null;

  return (
    <div role="status" aria-live="polite" style={{ position: 'fixed', top: '1rem', right: '1rem', zIndex: 20000, display: 'flex', alignItems: 'center', gap: '0.75rem', padding: '0.85rem 1rem', backgroundColor: '#fff', color: '#212529', border: '1px solid #ced4da', borderRadius: '6px', boxShadow: '0 4px 16px rgba(0, 0, 0, 0.2)', fontSize: '14px', fontWeight: 600 }}>
      <span style={{ width: '22px', height: '22px', flex: '0 0 22px', border: '3px solid #d8e3ef', borderTopColor: '#007bff', borderRadius: '50%', animation: 'receipt-extraction-spin 0.8s linear infinite' }} />
      Scanning receipt...
      <style>{'@keyframes receipt-extraction-spin { to { transform: rotate(360deg); } }'}</style>
    </div>
  );
};

export default ReceiptExtractionStatus;